import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import moment from 'moment/moment';
import { PermissionManagerApiClient } from '@nimbus-global/features/permissions/services/api/permission-manager.api-client';
import { CacheService, IEntityCacheService } from '@nimbus-library/features/cache';

@Injectable({
  providedIn: 'root',
})
export class UserHashService {
  private readonly myHashCache: IEntityCacheService<string>;

  public constructor(
    cacheService: CacheService,
    private readonly permissionManagerApiClient: PermissionManagerApiClient,
  ) {
    this.myHashCache = cacheService.for<string>('my-hash', {
      cacheMaxAge: moment.duration(12, 'hours'),
      preloadMaxAge: moment.duration(12, 'hours'),
    });
  }

  public getMyHash$(): Observable<string> {
    return this.permissionManagerApiClient.getMyHash().pipe(this.myHashCache.useCache('', false));
  }
}
